(function () {
  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function initBanner(banner) {
    var end = new Date(banner.dataset.end).getTime();
    if (isNaN(end)) return;

    var action = banner.dataset.expiredAction;
    var timer = banner.querySelector('[data-promo-banner-timer]');
    var expiredMessage = banner.querySelector('[data-promo-banner-expired]');
    var fields = {
      days: banner.querySelector('[data-promo-banner-days]'),
      hours: banner.querySelector('[data-promo-banner-hours]'),
      minutes: banner.querySelector('[data-promo-banner-minutes]'),
      seconds: banner.querySelector('[data-promo-banner-seconds]'),
    };
    var baseLabel = timer ? timer.getAttribute('aria-label') : '';
    var lastMinute = null;
    var intervalId = null;

    function render(left) {
      var total = Math.max(0, Math.floor(left / 1000));
      var days = Math.floor(total / 86400);
      var hours = Math.floor((total % 86400) / 3600);
      var minutes = Math.floor((total % 3600) / 60);
      var seconds = total % 60;

      fields.days.textContent = pad(days);
      fields.hours.textContent = pad(hours);
      fields.minutes.textContent = pad(minutes);
      fields.seconds.textContent = pad(seconds);

      if (lastMinute !== minutes) {
        lastMinute = minutes;
        timer.setAttribute('aria-label', baseLabel + ': ' + days + ' d ' + hours + ' h ' + minutes + ' min');
      }
    }

    function expire() {
      window.clearInterval(intervalId);
      render(0);
      // Keep the banner visible in the theme editor so it can be configured.
      if (window.Shopify && window.Shopify.designMode) return;
      if (action === 'hide') {
        banner.hidden = true;
        document.documentElement.classList.add('promo-banner-ended');
        updateOffset();
      } else if (action === 'message') {
        timer.hidden = true;
        if (expiredMessage) expiredMessage.hidden = false;
      }
    }

    function tick() {
      var left = end - Date.now();
      if (left <= 0) {
        expire();
      } else {
        render(left);
      }
    }

    tick();
    if (end - Date.now() > 0) intervalId = window.setInterval(tick, 1000);
  }

  // The theme header is fixed at the top; keep it just below the visible part of the banner.
  function updateOffset() {
    var banner = document.querySelector('[data-promo-banner]');
    var offset = 0;
    if (banner && !banner.hidden) {
      offset = Math.max(0, Math.round(banner.getBoundingClientRect().bottom));
    }
    document.documentElement.style.setProperty('--promo-banner-offset', offset + 'px');
  }

  function initAll() {
    document.querySelectorAll('[data-promo-banner][data-end]:not([data-end=""])').forEach(initBanner);
    updateOffset();
  }

  window.addEventListener('scroll', updateOffset, { passive: true });
  window.addEventListener('resize', updateOffset);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
